import { createContact, updateContact } from 'common/api/v1/contacts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_CONTACT,
    SAVE_CONTACT_FAILURE,
    SAVE_CONTACT_SUCCESS,
} from '../actionTypes';
import { createContactModalActions } from '../reducer';

import closeModal from './closeModal';

export default (values, onSuccess) => (dispatch) => {
    const newValues = {
        company_name: values.company_name,
        company_position: values.company_position,
        emails: JSON.stringify(values.emails),
        name: values.name,
        rfc: values.rfc,
        telephones: JSON.stringify(values.telephones),
        user: values.user,
    };

    dispatch(createContactModalActions[SAVE_CONTACT](null));

    const save = values.id
        ? () => updateContact({ ...values, ...newValues }, values.id)
        : () => createContact({ ...values, ...newValues });

    save()
        .then((response) => {
            dispatch(
                createContactModalActions[SAVE_CONTACT_SUCCESS](response.data),
            );
            dispatch(closeModal());
            showToast();
            if (onSuccess) onSuccess(response.data);
        })
        .catch((error) => {
            dispatch(
                createContactModalActions[SAVE_CONTACT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
